import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigurationService } from './configuration.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class MockInterceptor implements HttpInterceptor {
  constructor(private configurationService: ConfigurationService) {}

  intercept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    req: HttpRequest<any>,
    next: HttpHandler
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ): Observable<HttpEvent<any>> {
    const config = this.configurationService.getConfiguration();
    const mocks = environment.mockedApiCalls;
    const value = mocks ? mocks.find(mock => mock.method === req.method && req.url.includes(mock.path)) : undefined;
    if (value != undefined) {
      const baseUrl = config.driftApi ?? '';
      const mockApi = environment.mockApi ?? '';
      const mockApiKey = atob(environment.mockApiKey ?? '');
      const mockurl = req.url.replace(baseUrl, mockApi);

      console.info(`Overriding API request: ${req.url} to use mock endpoint: ${mockurl}`);

      const modifiedReq = req.clone({
        url: mockurl,
        setHeaders: {
          'x-api-key': mockApiKey
        }
      });
      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
